import { CaretType, PositionType } from '@com-delta-idp/mnx-ui-kit';

export interface ActionBar {
  caret: ActionBarCaret;
  label: ActionBarLabel;
}

export interface ActionBarCaret {
  type: CaretType;
  position: PositionType;
  ariaLabel: string;
  show: boolean;
}

export interface ActionBarLabel {
  position: PositionType;
  show: boolean;
  text: string;
  id?: string;
  type?: string;
  ariaLabel?: string;
}

export enum ActionBarAriaLabel {
  COLLAPSED = 'collapsed promotion section',
  EXPANDED = 'expanded promotion section'
}
